import { useEffect } from "react";

export const useKeyboardShortcut = (
  key?: string,
  callback?: () => void | Promise<unknown>,
) => {
  useEffect(() => {
    if (key === undefined || callback === undefined) {
      return;
    }
    const handler = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === key) {
        void callback();
      }
    };
    window.addEventListener("keydown", handler);
    return () => {
      window.removeEventListener("keydown", handler);
    };
  }, [key, callback]);
};
